<template>
  <el-dialog
    class="authModal"
    :title="getTitle"
    :visible.sync="showModal"
    @close="handleCancel"
    width="80%"
  >
    <el-row :gutter="10">
      <el-col :span="6" :xs="24" class="mb-15">
        <el-card shadow="none">
          <div slot="header">
            <el-input placeholder="输入关键字进行过滤" v-model="filterText">
            </el-input>
          </div>
          <el-tree
            highlight-current
            default-expand-all
            class="room-tree"
            ref="roomTree"
            node-key="id"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            @node-click="handleNodeClick"
          >
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="18" :xs="24">
        <el-card shadow="none">
          <div slot="header">
            <span>按门禁组筛选：</span>
            <el-select
              v-model="group"
              placeholder="请选择"
              @change="changeGroup"
            >
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <el-row class="mt-15 change-main" :gutter="10">
            <el-col :span="10" :xs="24">
              <el-card shadow="none">
                <el-table
                  :data="leftCheckData"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    label="设备名称"
                    prop="lock_name"
                    :min-width="80"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column
                    label="时间组"
                    prop="slot_id"
                    :min-width="100"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.slot_id"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in timeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24" ref="twoButton" style="height: 100%">
              <el-button
                type="primary"
                :disabled="!rightCheckArr.length"
                icon="el-icon-arrow-left"
                @click="handleToLeft"
              ></el-button>
              <el-button
                type="primary"
                :disabled="!leftCheckArr.length"
                icon="el-icon-arrow-right"
                @click="handleToRihgt"
              ></el-button>
            </el-col>
            <el-col :span="10" :xs="24">
              <el-card shadow="none">
                <el-table
                  :data="allSelect"
                  @selection-change="handleRightChange"
                >
                  <el-table-column
                    type="selection"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    label="设备名称"
                    prop="lock_name"
                    :min-width="80"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column
                    label="时间组"
                    prop="slot_id"
                    :min-width="100"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.slot_id"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in timeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button
        v-has="
          '/person_lock/edit' ||
          '/person_lock/batch_add' ||
          '/person_lock/batch_del'
        "
        type="primary"
        @click="handleConfirm('manForm')"
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from "@/common/api";
export default {
  props: {
    isShow: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      showModal: this.isShow,
      filterText: "",
      defaultProps: {
        label: "name",
        children: "children",
      },
      treeData: [],
      // 门禁组列表
      groupList: [],
      // 时间组列表
      timeList: [],
      // 门禁组选中
      group: "",
      // 模拟穿梭
      leftCheckArr: [],
      rightCheckArr: [],
      leftCheckData: [],
      rightCheckData: [],
      allSelect: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.roomTree.filter(val);
    },
  },
  computed: {
    getTitle() {
      return this.data.type === "multi"
        ? "批量授权"
        : this.data.type === "del"
        ? "批量删除授权"
        : "授权";
    },
  },
  created() {
    this.getAreaTree();
    this.getPassGroupList();
    this.getTimeList();
    if (this.data.type === "single") {
      this.getPersonAuthList();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollStart);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollStart);
  },
  methods: {
    handleScrollStart() {
      //this.$refs.twoButton.getBoundingClientRect().top =document.documentElement.scrollTop || document.body.scrollTop;
      //this.$refs.twoButton.currentTop = document.body.scrollTop;
    },
    // 左侧选中
    handleSelectionChange(val) {
      this.leftCheckArr = val;
    },
    // 右侧选中
    handleRightChange(val) {
      this.rightCheckArr = val;
    },
    // 左侧穿梭按钮
    handleToRihgt() {
      let checkedArr = this.leftCheckArr.map((item) => {
        return item.lock_id;
      });
      this.leftCheckData = this.leftCheckData.filter((item) => {
        return checkedArr.indexOf(item.lock_id) < 0;
      });
      this.rightCheckData = this.rightCheckData.concat(this.leftCheckArr);
      this.allSelect = this.allSelect.concat(this.leftCheckArr);
    },
    // 右侧穿梭按钮
    handleToLeft() {
      let checkedArr = this.rightCheckArr.map((item) => {
        return item.lock_id;
      });
      this.rightCheckData.forEach((item) => {
        if (checkedArr.indexOf(item.lock_id) > -1) {
          this.leftCheckData.push(item);
        }
      });
      this.rightCheckData = this.rightCheckData.filter((item) => {
        return checkedArr.indexOf(item.lock_id) < 0;
      });
      // this.leftCheckData = this.leftCheckData.concat(this.rightCheckArr)
      let tmpAllArr = [];
      this.allSelect.forEach((item) => {
        if (checkedArr.indexOf(item.lock_id) < 0) {
          tmpAllArr.push(item);
        }
      });
      this.allSelect = tmpAllArr;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 获取已有权限
    getPersonAuthList() {
      fetch.getPersonAuthList({ person_id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.allSelect = data.list;
          },
          (err) => {
            this.$message.error(err);
          }
        );
      });
    },
    // 获取树结构数据
    getAreaTree() {
      return Promise.resolve(
        fetch.getAreaTree({}).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.treeData = data.treeData;
            },
            (err) => {
              this.$message.error(err);
            }
          );
        })
      );
    },
    // 获取门禁组
    getPassGroupList() {
      fetch.getPassGroupList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.groupList = data.list;
          },
          (err) => {
            this.$message.error(err);
          }
        );
      });
    },
    // 获取时间组列表
    getTimeList() {
      fetch.getTimeList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.timeList = data.list;
          },
          (err) => {
            this.$message.error(err);
          }
        );
      });
    },
    // 获取设备列表
    roomLockList(val) {
      fetch.roomLockList({ area_id: val }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            let leftArr = [];
            let rightArr = [];
            let allSelectIds = this.allSelect.map((item) => {
              return item.lock_id;
            });
            data.list.forEach((item) => {
              // 如未选中时间组则默认选中第一个
              if (!item.slot_id) {
                item.slot_id = this.timeList[0].id;
              }
              if (allSelectIds.indexOf(item.lock_id) < 0) {
                leftArr.push(item);
              } else {
                rightArr.push(item);
              }
            });
            this.leftCheckData = leftArr;
            this.rightCheckData = rightArr;
          },
          (err) => {
            this.$message.error(err);
          }
        );
      });
    },
    // 树形菜单单击
    handleNodeClick(data) {
      this.leftCheckData = [];
      this.rightCheckData = [];
      this.group = "";
      if (data.area_type === "area_type_yes") {
        this.roomLockList(data.id);
      } else {
        this.$message.info("该机构下暂无设备数据");
      }
    },
    // 切换门禁组
    changeGroup(val) {
      this.leftCheckData = [];
      this.rightCheckData = [];
      this.getPassRuleList(val);
    },
    // 获取门禁规则
    getPassRuleList(val) {
      fetch.getPassRuleList({ group_id: val }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            let leftArr = [];
            let rightArr = [];
            let allSelectIds = this.allSelect.map((item) => {
              return item.lock_id;
            });
            data.list.forEach((item) => {
              if (allSelectIds.indexOf(item.lock_id) < 0) {
                leftArr.push(item);
              } else {
                rightArr.push(item);
              }
            });
            this.leftCheckData = leftArr;
            this.rightCheckData = rightArr;
          },
          (err) => {
            this.$message.error(err);
          }
        );
      });
    },
    handleConfirm() {
      let lockStr = this.allSelect.map((item) => {
        return {
          id: item.id,
          lock_id: item.lock_id,
          slot_id: item.slot_id,
        };
      });
      if (this.data.type === "single") {
        fetch
          .personAuth({
            lockData: JSON.stringify(lockStr),
            personId: this.data.id,
          })
          .then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success("操作成功");
                this.handleCancel("refresh");
              },
              (err) => {
                this.$message.error(err);
              }
            );
          });
      } else if (this.data.type === "multi") {
        fetch
          .multiPersonAuth({
            lockData: JSON.stringify(lockStr),
            personId: this.data.id,
          })
          .then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success("操作成功");
                this.handleCancel("refresh");
              },
              (err) => {
                this.$message.error(err);
              }
            );
          });
      } else {
        fetch
          .multiDelPersonAuth({
            lockData: JSON.stringify(lockStr),
            personId: this.data.id,
          })
          .then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success("操作成功");
                this.handleCancel("refresh");
              },
              (err) => {
                this.$message.error(err);
              }
            );
          });
      }
    },
    handleCancel(type) {
      this.$emit("handleClose", type);
    },
  },
};
</script>

<style lang="less" scoped>
.change-main {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // align-items: center;
}
</style>
<style lang="less">
.authModal {
  .el-transfer-panel {
    width: 300px;
    .el-transfer-panel__item {
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>
